<template>
  <div class="column-multline" style="font-weight: normal">
    <div @click="click" style="margin-bottom: 10px">
      <span class="small-title-destaque">Tipo de Consulta:</span>
      <span class="bold">{{tipoConsulta(row[column.field[0]])}}</span>
      <span v-if="Number(row[column.field[0]]) === 1" class="small-title">
        Local: {{row[column.field[1]].descricao}},
        {{row[column.field[1]].endereco.cidade}},
        {{row[column.field[1]].endereco.estado}}</span>
    </div>
  </div>
</template>
<script>

export default {
  name: 'LocalItem',
  props: ['column', 'row'],
  methods: {
    tipoConsulta (value) {
      let tipo
      if (value === '2') {
        tipo = 'Teleconsulta'
      } else {
        tipo = 'Consulta presencial'
      }
      return tipo
    },
    click () {
      if (this.column && this.column.click) {
        this.column.click(this.row)
      }
      this.$emit('click', this.row)
    }
  }
}
</script>
<style lange="less">
@import url('https://fonts.googleapis.com/css2?family=Nunito:wght@200&family=Open+Sans:wght@300&display=swap');
.small-title-destaque {
  font-family: 'Open Sans', sans-serif;;
  font-size: 11px;
  text-align: left;
  line-height: 15px;
  color: #555;
  font-weight: 400;
  display: block;
  word-break: break-word;
}
.small-title {
  font-family: 'Open Sans', sans-serif;;
  font-size: 11px;
  text-align: left;
  line-height: 15px;
  color: #333333;
  font-weight: 400;
  display: block;
  word-break: break-word;
}
.bold {
  font-family: "Open Sans", SansSerif;
  color: #333333;
  opacity: 1;
  font-weight: 600;
}
</style>
